export default __webpack_public_path__ + "static/media/email.996c814d.svg";